/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { OrganisationOwnerPathParams, OrganisationOwnerResponse } from '../types/OrganisationOwner'

/**
 * POST /organisations/:organisation/owner
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::owner
 */
export async function organisationOwner(
	organisation: OrganisationOwnerPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationOwnerResponse>> {
	return axiosInstance.post(`/organisations/${organisation}/owner`, undefined, config)
}
